// Amount of probes per virtual machine
const VM_PROBES_AMOUNT = 4;
// Memory dedicated to virtual machine in Gb
const VM_DEDICATED_MEMORY = 7.5;

export { VM_PROBES_AMOUNT, VM_DEDICATED_MEMORY };
